module.exports = __webpack_public_path__ + "img/violet_003.e2094346.png";